module.exports = __webpack_public_path__ + "img/冀州暖气输液器1.7faaad0b.jpg";